var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Print, colour=NeutralDefault, htmlTag=img, assetKey=Content, state=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "print",
    d: "M16.8295 8V5H8.82952V8H6.82952V3H18.8295V8H16.8295ZM18.8295 12.5C19.1129 12.5 19.3504 12.4042 19.542 12.2125C19.7337 12.0208 19.8295 11.7833 19.8295 11.5C19.8295 11.2167 19.7337 10.9792 19.542 10.7875C19.3504 10.5958 19.1129 10.5 18.8295 10.5C18.5462 10.5 18.3087 10.5958 18.117 10.7875C17.9254 10.9792 17.8295 11.2167 17.8295 11.5C17.8295 11.7833 17.9254 12.0208 18.117 12.2125C18.3087 12.4042 18.5462 12.5 18.8295 12.5ZM16.8295 19V15H8.82952V19H16.8295ZM18.8295 21H6.82952V17H2.82952V11C2.82952 10.15 3.12119 9.4375 3.70452 8.8625C4.28785 8.2875 4.99619 8 5.82952 8H19.8295C20.6795 8 21.392 8.2875 21.967 8.8625C22.542 9.4375 22.8295 10.15 22.8295 11V17H18.8295V21ZM20.8295 15V11C20.8295 10.7167 20.7337 10.4792 20.542 10.2875C20.3504 10.0958 20.1129 10 19.8295 10H5.82952C5.54619 10 5.30869 10.0958 5.11702 10.2875C4.92535 10.4792 4.82952 10.7167 4.82952 11V15H6.82952V13H18.8295V15H20.8295Z",
    fill: "#2F3846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.7d1322aef3d9a116e0c1fbeee0dc3284.svg";
export { ForwardRef as ReactComponent };